/**
 * The Theme resource processor, on the shared `createResourceProcessor` loop. It reads
 * the owning file's cached parse, addresses a **Sub-resource path**
 * (`res://file.tres::SubId`) and loads its fonts through the font processor.
 */
import { createResourceProcessor } from '../createResourceProcessor';
import { THEME_TYPES } from '../styles/theme/decode';
import { buildThemeResource } from '../styles/theme/loadTheme';
export function createThemeProcessor(eventBus, loadSection, 
/** The font loader for the Theme at `themeKey`, so each font it reads is recorded against it. */
loadFontFor) {
    return createResourceProcessor({
        eventBus,
        resourceType: 'theme',
        addressesSubResources: true,
        // Fonts load through a different processor (`loader.fonts`), so `ResourceLoader`
        // injects the loader rather than this closing over itself as `createFontProcessor` does.
        loadDirectly: async (path) => buildThemeResource(path, await loadSection(path, THEME_TYPES), loadFontFor(path)),
    });
}
//# sourceMappingURL=createThemeProcessor.js.map